<div class="mt-3 flex-column" [formGroup]="subForm">
  <div>
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
      for="label"><strong>{{variables.addChangeRemoveConfig}}.</strong></span>
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG"
      [showWhen]="!canEditCatalog"><strong>{{variables.catalogConfigs}}</strong></span>

    @if (listItem && listItem.length > 0) {
    <div class="list-group-control mt-3">
      <div class="d-flex list-group-control-header">
        <div class="list-group-control-header-name">{{variables.name}}</div>
        <div class="list-group-control-header-complexity">{{variables.effort}} ({{variables.hours}})</div>
        <div class="list-group-control-header-complexity">{{variables.profile}}</div>
        <div class="list-group-control-item-icons"></div>
      </div>
      @for (item of listItem; track item) {
      <div class="list-group-control-item">
        <div class="list-group-control-item-name">{{item.name}}</div>
        <div class="list-group-control-item-complexity">{{item.complexity}}</div>
        <div class="list-group-control-item-complexity">{{ getProfileName(item.profileId) }}</div>
        <div class="list-group-control-item-icons action_buttons">
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.editConfiguration}}" (click)="openDialogEditProjectConfig(item)"
            class="icon-edit me-3 action_buttons-item">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.removeConfiguration}}" (click)="openDialogRemove(item.name, 'configuration')"
            class="icon-close me-1 action_buttons-item">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
          </span>
        </div>
      </div>
      }
    </div>
    }
    <br>
    @if (!listItem || listItem.length === 0) {
    <div class="mt-3"></div>
    }
    <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
      class="addItemsInCatalogStepBtn" (click)="addProjectConfig()"
      message="{{variables.addNewConfiguration}}"></app-button>
  </div>

  <br><br><br>

  <div class="mt-5">
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" class="mb-3"
      for="label"><strong>{{variables.addChangeRemoveParams}}.</strong></span>
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG "
      [showWhen]="!canEditCatalog"><strong>{{variables.catalogParams}}</strong></span>

    @if (listItemParams && listItemParams.length > 0) {
    <div class="list-group-control mt-3">
      <div class="d-flex list-group-control-header">
        <div class="list-group-control-header-name">{{variables.name}}</div>
        <div class="list-group-control-header-complexity">{{variables.effort}} ({{variables.hours}})</div>
        <div class="list-group-control-header-complexity">{{variables.profile}}</div>
        <div class="list-group-control-item-icons"></div>
      </div>
      @for (item of listItemParams; track item) {
      <div class="list-group-control-item">
        <div class="list-group-control-item-name">{{item.name}}</div>
        <div class="list-group-control-item-complexity">{{item.complexity}}</div>
        <div class="list-group-control-item-complexity">{{ getProfileName(item.profileId) }}</div>
        <div class="list-group-control-item-icons action_buttons">
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.editParameter}}" (click)="openDialogEditProjectParams(item)"
            class="icon-edit me-3 action_buttons-item">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.removeParameter}}" (click)="openDialogRemove(item.name, 'params')"
            class="icon-close me-1 action_buttons-item">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
          </span>
        </div>
      </div>
      }
    </div>
    }
    <br>
    @if (!listItemParams || listItemParams.length === 0) {
    <div class="mt-3"></div>
    }
    <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
      class="addItemsInCatalogStepBtn addItemsBtnBigger" (click)="addParams()"
      message="{{variables.addNewParams}}"></app-button>
  </div>
</div>